module.exports = __webpack_public_path__ + "8d2add21339e32c5d8cfa4eb745981fe.fbx";